import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = React.useState({
        email: '',
        password: ''
    });
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const API_URL = import.meta.env.VITE_API_URL || 'http://localhost/isplw/api';

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(`${API_URL}/auth.php`, {
                action: 'login',
                ...formData
            });

            if (response.data.status === 'success') {
                localStorage.setItem('user', JSON.stringify(response.data.data));
                navigate('/client-portal');
                // Force header update
                window.dispatchEvent(new Event('authChange'));
            }
        } catch (err) {
            setError(err.response?.data?.message || "Invalid email or password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex flex-col">
            <Header />
            <main className="flex-1 flex items-center justify-center py-12 px-4 md:px-6 mt-16">
                <div className="max-w-md w-full bg-card rounded-2xl shadow-xl border border-border p-8 md:p-10">
                    <div className="text-center mb-8">
                        <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-4 text-primary">
                            <Icon name="LogIn" size={32} />
                        </div>
                        <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">Welcome Back</h1>
                        <p className="text-muted-foreground">Log in to manage your projects and services</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        {error && (
                            <div className="bg-error/10 border border-error/20 text-error p-3 rounded-lg flex items-center gap-2 text-sm italic">
                                <Icon name="AlertCircle" size={16} />
                                {error}
                            </div>
                        )}

                        <Input
                            label="Email Address"
                            name="email"
                            type="email"
                            placeholder="john@example.com"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />

                        <Input
                            label="Password"
                            name="password"
                            type="password"
                            placeholder="••••••••"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />

                        <div className="flex items-center justify-between text-sm">
                            <label className="flex items-center gap-2 cursor-pointer text-muted-foreground">
                                <input type="checkbox" className="rounded border-border text-primary focus:ring-primary" />
                                <span>Remember me</span>
                            </label>
                            <a href="#" className="text-primary hover:underline font-medium">Forgot password?</a>
                        </div>

                        <Button
                            type="submit"
                            variant="default"
                            className="w-full"
                            loading={loading}
                        >
                            Log In
                        </Button>

                        <p className="text-center text-sm text-muted-foreground mt-6">
                            Don't have an account?{' '}
                            <Link to="/signup" className="text-primary font-semibold hover:underline">
                                Sign Up
                            </Link>
                        </p>
                    </form>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Login;
